import React from "react";
import { Outlet } from "react-router-dom";

function Communication() {
  return (
    <div>
      <Outlet />
    </div>
  );
}

export default Communication;
